import type { OilViscosityParameters } from "../../d";

// returns mu_o cP
export function deadOilViscosityCalculator(params: OilViscosityParameters): {
  x: number;
  deadOilViscosity: number;
} {
  const { temperatureF, oilSpecificGravity } = params;

  // Q30: =(D4**(-1.163))*EXP((13.108-6.591/D17))
  const x =
    temperatureF ** -1.163 * Math.exp(13.108 - 6.591 / oilSpecificGravity);

  // Q32: =(10**(Q30))-1
  const deadOilViscosity = 10 ** x - 1;

  return {
    x,
    deadOilViscosity
  };
}
